import axios from 'axios'
import Lot from '~/models/lot'
import { HeardAboutUsReason } from '~/models'
import { $axios } from '~/utils/api'
import PagedResponse from '~/models/pagedResponse'

const END_POINT = '/map'

const CancelToken = axios.CancelToken
const cancelTokens: {
  consumerMapHomes: any
  consumerMapHomesites: any
  propertiesList: any
} = {
  consumerMapHomes: null,
  consumerMapHomesites: null,
  propertiesList: null,
}

const getPropertiesList = (
  page: number,
  queryParams?: string
): Promise<PagedResponse<Lot>> => {
  const request = `${END_POINT}/lots?page=${page}${
    queryParams ? `&${queryParams}` : ''
  }`
  cancelPreviousToken('propertiesList')
  cancelTokens.propertiesList = CancelToken.source()

  return $axios.$get(request, {
    cancelToken: cancelTokens.propertiesList.token,
  })
}

const getHomeSiteList = (
  page: number,
  queryParams?: string
): Promise<PagedResponse<Lot>> => {
  return $axios.$get(
    `${END_POINT}/homesites?page=${page}${queryParams ? `&${queryParams}` : ''}`
  )
}

const getParcelIds = (queryParams?: string) => {
  return $axios.$get(
    `${END_POINT}/parcel_ids${queryParams ? `?${queryParams}` : ''}`
  )
}

const getLot = (parcelId: string): Promise<PagedResponse<Lot>> =>
  $axios.$get(`${END_POINT}/lots?parcel_id=${parcelId}`)

const cancelPreviousToken = (name: string): void => {
  if (cancelTokens[name]) {
    cancelTokens[name].cancel()
    cancelTokens[name] = null
  }
}

const getContactFormHeardAboutUsReasonsAsync = (): Promise<
  Array<HeardAboutUsReason>
> => $axios.$get(`${END_POINT}/consumer/heard_about_us_reasons`)

const saveUsersRequestForMoreInformationAboutMultipleLotsAsync = (
  data: any
): Promise<any> => {
  return $axios.$post(`${END_POINT}/consumer/request_info`, data)
}

export {
  getPropertiesList,
  getParcelIds,
  getLot,
  getContactFormHeardAboutUsReasonsAsync,
  saveUsersRequestForMoreInformationAboutMultipleLotsAsync,
}
